import script from "./ToastProvider.vue?vue&type=script&lang=tsx"
export * from "./ToastProvider.vue?vue&type=script&lang=tsx"

import "./ToastProvider.vue?vue&type=style&index=0&id=caf53030&lang=scss"

const __exports__ = script;

export default __exports__